import React, { Component } from 'react';


// Layouts
import Footer from "../layout/Footer";
import Header from "../layout/Header";

// Components
import SponsorsLogo from "../components/SponsorsLogo";
import Tab1 from '../components/Tab1';
import HeroHeader from '../components/HeroHeader';


// Slick Slider - Package
import Cookies from 'universal-cookie';
import service from '../common/service';
import { Helmet } from 'react-helmet';

let sub;
const cookies = new Cookies();

class Home extends Component {
  constructor() {
    super();
    this.state = {
      films_tab: [
        { title: 'Tickets', isActive: false, index: 0, route: '/' },
        { title: 'Getting Around', isActive: false, index: 1, route: '/gettingaround' },
        { title: 'Venues', isActive: false, index: 2, route: '/venues' },
        { title: 'Festival Stores', isActive: false, index: 3, route: '/festival-stores' },
        { title: 'Accessibility', isActive: false, index: 4, route: '/accessibility' },
        { title: 'COVID-19', isActive: false, index: 5, route: '/covid-19' },
        { title: 'Safety & Belonging', isActive: false, index: 6, route: '/safety-belonging' },
        { title: 'FAQ', isActive: false, index: 7, route: '/faq' },

      ],
      // selectTab: 0,
      homeData: "",
      festInfo: {},
      navFlag: true,
      HTFonlinelink: true,
      festival: false,
      // isTabLoader:false
    };
    this.apiServe = new service();
    // let {id}=useRouteMatch()
  }

  // componentWillUnmount = () => {
  //   sub.unsubscribe();
  // };

  componentDidMount = () => {

    // ((this.props.history.location.pathname).split('/')[2]) && this.state.films_tab.map((item,i)=>{
    //    if(item.route===`/${(this.props.history.location.pathname).split('/')[2]}`){
    //     this.setState({
    //       selectTab:item.index
    //     })
    //     item.isActive=true
    //     this.getTabInfo(i)
    //   }
    // })
   
      const tab_data= (this.props.history.location.pathname).split('/')[2] === undefined || (this.props.history.location.pathname).split('/')[2] === '' ?  this.state.films_tab[0] : this.state.films_tab.find(e => e.route === `/${(this.props.history.location.pathname).split('/')[2]}`)
      tab_data && this.setState({
        selectTab:tab_data.index,
        films_tab:{
          ...this.state.films_tab,
          isActive:true
        }
      })
    // this.apiServe.sendevent("howToFestInPerson|gettingAround|getDetail", {})
    // this.apiServe.sendevent("howToFestInPerson|boxOffice|getDetail", {})

    this.setState({
      isTabLoader:true
    })

    // const tab_data = this.state.films_tab.find(e => e.route === `/${this.props.match.params.inperson}`)
    console.log('tab_data',tab_data);
    if (tab_data) {
      this.switchTab(tab_data)
      // this.getTabInfo(tab_data.index) 
    }


    let particularUser = cookies.get("SundanceNewUser") || cookies.get("particularNewUser");

    if (particularUser && particularUser.token) {
      this.apiServe.sendevent("authentication", {
        token: particularUser.token,
      });
    }

    // Window Resize Event
    window.addEventListener('resize', this.windowResize);

    sub = this.apiServe.getevent().subscribe((response) => {
      switch (response.event) {
        case "authentication":
          if (response.error) {
            // console.log(response.error);
            let Zone = localStorage.getItem('TIMEZONE')
            localStorage.clear();
            if (Zone) localStorage.setItem('TIMEZONE', Zone)
          } else {
            localStorage.setItem("loggedInUser", response.data.user.role);
            localStorage.setItem("myLoginToken", response.data.token);
            this.getProfile();
          }

          break;
        case "user|getProfile":
          if (response.error) {
            // console.log(response.error);
          } else {
            if (localStorage.getItem("myLoginToken")) {
              let userInfo = {
                fname: response.data.fname,
                lname: response.data.lname,
                image: response.data.image,
								showMyLibrary:response.data.showMyLibrary && response.data.showMyLibrary

              };
              localStorage.setItem("Header", JSON.stringify(userInfo));
            }

            this.setState({ Header: true });
            this.forceUpdate();
          }
          break;
        default:
          break;
      }

    });

    // Hide video controls on no activity (5 seconds)
    let video = document.querySelector(".sd_video_wpr"),
      timeout;
    if (video) {
      video.addEventListener("mousemove", function () {
        if (document.querySelector('.video-react-control-bar')) {
          document
            .querySelector(".video-react-control-bar")
            .classList.remove("video-react-control-out");

          clearTimeout(timeout);

          timeout = setTimeout(function () {
            document
              .querySelector(".video-react-control-bar")
              .classList.add("video-react-control-out");
          }, 5000);
        }
      });
    }
  };


  // Window Resize Event
  windowResize = () => {
    if (window.innerWidth < 769) {
      this.setState({
        navFlag: false,
      });
    } else {
      this.setState({
        navFlag: true,
      });
    }
  };
  getProfile = () => {
    this.apiServe.sendevent("user|getProfile", {});
  };

  HTFOnline = () => {
    this.setState({
      HTFonlinelink: false
    }, () => {
      this.props.history.push("/online")
    })
  }
 
   getTabInfo = (selectTab) => {
    if (selectTab === 0 || selectTab===undefined) {
      this.apiServe.sendevent("howToFestInPerson|boxOffice|getDetail", {})
      this.setState({isTabLoading:true})
    } else if (selectTab === 1) {
      this.apiServe.sendevent("howToFestInPerson|gettingAround|getDetail", {})
      this.setState({isTabLoading:true})
    } else if (selectTab === 2) {
      this.apiServe.sendevent("howToFestInPerson|venues|getDetail", {})
      this.setState({isTabLoading:true})
    } else if (selectTab === 3) {
      this.apiServe.sendevent("howToFestInPerson|festivalStores|getDetail", {})
      this.setState({isTabLoading:true})
    } else if (selectTab === 4) {
      this.apiServe.sendevent("howToFestInPerson|accessibility|getDetail", {})
      this.setState({isTabLoading:true})
    } else if (selectTab === 5) {
      this.apiServe.sendevent("howToFestInPerson|healthWellness|getDetail", {})
      this.setState({isTabLoading:true})
    } else if (selectTab === 6) {
      this.apiServe.sendevent("howToFestInPerson|safetyBelonging|getDetail", {})
      this.setState({isTabLoading:true})
    } else if (selectTab === 7) {
      this.apiServe.sendevent("howToFestInPerson|moreInfo|getDetail", {})
      this.setState({isTabLoading:true})
    }
  }
  scrollTop = () => {
    let scrolltab = document.querySelectorAll(".tab_active")[0];
    let offset= scrolltab?.offsetTop;
    console.log("offset",  scrolltab?.offsetTop);
    if (offset) {
      window.scrollTo({
        top: offset - 100,
        behavior: "smooth"
      });
    }
  }
  // Switch Tabs
  switchTab = (tab_data) => {
    // let getId = document.getElementsByClassName(tab_data)?.offsetTop;
    
    var films_tab_copy = [...this.state.films_tab];
    films_tab_copy.forEach((tab) => {
      if (tab.title === tab_data.title) {
        if(window.innerWidth > 768){
          tab.isActive = true;
          // let activeTab = document.querySelector(".tab_active");
          // let offset= activeTab?.offsetTop - 100;
          // window.scrollTo({ top:offset , behavior: "smooth" });
          // console.log("offset",offset);
        }
        else{
          tab.isActive = !tab.isActive;
          console.log("films_tab_copy",films_tab_copy);
          setTimeout(() => {
                let activeTab = document.querySelector(".tab_active");
                let offset= activeTab?.offsetTop - 100;
                window.scrollTo({ top:offset , behavior: "smooth" });
                console.log("offset",offset);
          }, 300);
        }
      }
      else {
        tab.isActive = false
      }
    });
    this.setState({
      films_tab: films_tab_copy,
      selectTab: tab_data.index,

    });
    this.getTabInfo(tab_data.index)
    this.props.history.push(`/inperson${tab_data.route}`)
  }
  setFestInfo = (info) => {
    this.setState({ festInfo: info })
  }
  stopLoader = ()=>{
    this.setState({isTabLoading:false})
    this.forceUpdate()
  }
  render() {
    // State
    const { films_tab, selectTab, festInfo } = this.state;
// console.log(id);
    console.log('------------',(this.props.history.location.pathname).split('/')[2]);
    console.log('selectTab',selectTab);

    return (
      <div className="home">
        <Helmet>
					<meta property="og:url" content={`${process.env.REACT_APP_HOME_PAGE}how-to-fest/inperson/${this.props.match?.params?.id ? this.props.match?.params?.id : ''}` } />
					<meta property="og:type" content='article' />
					<meta property="og:title" content={`${selectTab === 0 ? 'How to Fest In-Person' :films_tab.find(_=>_.index === selectTab)?.title } | 2023 Sundance Film Festival`}/>
					<meta property="og:description" content='' />
					<meta property="og:image" content="https://d2wsrejhnxatgp.cloudfront.net/imgpsh_fullsize_festival_2023.png" />

					<meta name="twitter:card" content="summary_large_image" />
					<meta name="twitter:title"  content={`${selectTab === 0 ? 'How to Fest In-Person' :films_tab.find(_=>_.index === selectTab)?.title} | 2023 Sundance Film Festival`}/>
					<meta name="twitter:url" content={`${process.env.REACT_APP_HOME_PAGE}how-to-fest/inperson/${this.props.match?.params?.id ? this.props.match?.params?.id : ''}` } />
					<meta name="twitter:description" content=''/>
					<meta name="twitter:image" content="https://d2wsrejhnxatgp.cloudfront.net/imgpsh_fullsize_festival_2023.png" />
								
					<meta name="description" content={'Here’s everything you’ll need to know to make the most of your online Sundance Film Festival experience.'} />
					<meta name="keywords" content={`${selectTab === 0 ? 'How to Fest In-Person' : films_tab?.find(_=>_.index === selectTab)?.title}, Sundance Film Festival, 2023 Sundance Festival, Sundance Festival, Film Festival`} />
					<title>{`${selectTab === 0 ? 'How to Fest In-Person' : films_tab?.find(_=>_.index === selectTab)?.title} | 2023 Sundance Film Festival`}</title>
					<link rel="canonical" href={`${process.env.REACT_APP_HOME_PAGE}how-to-fest/inperson/${this.props.match?.params?.id ? this.props.match?.params?.id : ''}` } />
				</Helmet>
        {/* Header */}

        {/* <Header hero_header={true} history={this.props.history} /> */}
        <Header history={this.props.history} />

        <HeroHeader onlinelink={this.HTFOnline} HTFonlinelink={this.state.HTFonlinelink} />
        {/* <HeroHeader history={this.props.history}/> */}
        {/* Content */}

        {/* Tabs Section */}
        <section className="sd_home_section">
          <div className="sd_home_page_wpr">

            <div className="sd_home_tab_wpr">
              <div className="sd_inner_container">
                <ul>
                  {
                    films_tab.map((tab) => {
                      return (<>
                        <li className={`${tab.isActive ? 'tab_active active' : " "}`}  key={tab.title}>
                          <button className="sd_film_tab_button" onClick={this.switchTab.bind(this, tab)}>
                            {tab.title}<i class="arrow down"></i>
                          </button>
                          {
                            (!this.state.navFlag || window.innerWidth < 769) &&
                            <Tab1  selectTab={selectTab} festInfo={festInfo} isTabLoading={this.state.isTabLoading} stopLoader={this.stopLoader} setFestInfo={this.setFestInfo} />
                          }

                        </li>

                      </>)
                    })
                  }
                </ul>
              </div>
            </div>
            {
              this.state.navFlag && 
                <Tab1  selectTab={selectTab} festInfo={festInfo} setFestInfo={this.setFestInfo} stopLoader={this.stopLoader} isTabLoading={this.state.isTabLoading} />
            }
          </div>
        </section>


        {/* ShareBlock */}
        {/* <ShareBlock /> */}

        {/* Sponsors Logo */}
        <section className="sd_sponsors_section">
          <SponsorsLogo slider={true} />
        </section>
        

        {/* Footer */}
        <Footer />

      </div>
    )
  }
}

export default Home;